export default __webpack_public_path__ + "static/media/COVID-Icons-4.ba5bcc59.svg";